var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapa1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_822_1756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.13916 32.5367H6.79947",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13916 24.407H6.79947",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13916 40.6664H6.79947",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.791 24.407H22.9445",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.791 32.5367H22.9445",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.791 40.6664H22.9445",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7986 24.407H19.9521",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7986 32.5367H19.9521",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7986 40.6664H19.9521",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8062 24.407H16.9596",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8062 32.5367H16.9596",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8062 40.6664H16.9596",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7593 44.7313H33.1816C32.6639 44.7313 32.2441 44.3116 32.2441 43.7938V41.5402C32.2441 41.0224 32.6639 40.6027 33.1816 40.6027H46.7593C47.277 40.6027 47.6968 41.0224 47.6968 41.5402V43.7938C47.6968 44.3115 47.277 44.7313 46.7593 44.7313Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4695 13.4722L18.678 3.68064C18.4142 3.41692 18.0566 3.2688 17.6836 3.2688H1.10303",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9116 26.9195L45.3977 32.4056C45.6614 32.6693 45.8095 33.0269 45.8095 33.4V37.2999",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51325 7.81012H2.04053C1.52275 7.81012 1.10303 8.22984 1.10303 8.74762V11.0012C1.10303 11.519 1.52275 11.9387 2.04053 11.9387H13.377C13.8947 11.9387 14.3145 11.519 14.3145 11.0012V8.74762C14.3145 8.22984 13.8947 7.81012 13.377 7.81012H6.7945",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9883 14.221L43.5335 10.6758",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4827 20.7266L37.6665 16.5427",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44678 20.3422H24.637C25.9314 20.3422 26.9807 21.3915 26.9807 22.6859V26.1281C26.9807 27.4225 25.9314 28.4719 24.637 28.4719H3.44678C2.15237 28.4719 1.10303 27.4225 1.10303 26.1281V22.6859C1.10303 21.3915 2.15237 20.3422 3.44678 20.3422Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44678 28.4719H24.637C25.9314 28.4719 26.9807 29.5212 26.9807 30.8156V34.2578C26.9807 35.5522 25.9314 36.6016 24.637 36.6016H3.44678C2.15237 36.6016 1.10303 35.5522 1.10303 34.2578V30.8156C1.10303 29.5211 2.15237 28.4719 3.44678 28.4719Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9806 33.3693C28.9291 34.3734 31.1396 34.9406 33.4827 34.9406C41.3328 34.9406 47.6967 28.5768 47.6967 20.7266C47.6967 12.8765 41.3328 6.51263 33.4827 6.51263C25.7611 6.51263 19.4777 12.6698 19.2739 20.3422",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8687 44.7313H24.637C25.9314 44.7313 26.9807 43.6819 26.9807 42.3875V38.9453C26.9807 37.6509 25.9314 36.6016 24.637 36.6016H3.44678C2.15237 36.6016 1.10303 37.6509 1.10303 38.9453V42.3875C1.10303 43.6819 2.15237 44.7313 3.44678 44.7313H18.5874",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6967 20.7266H33.4827V34.9407",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_822_1756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.399902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapa1);
export default __webpack_public_path__ + "static/media/Capa_1.8dcf9cffa1a7de9cb55d61c8f4272186.svg";
export { ForwardRef as ReactComponent };